export default function isAbandonedCartRoute(query: { preference?: unknown }) {
  return 'preference' in query;
}
